import React, { useState } from 'react';
import { View, ScrollView } from 'react-native';
import { useForm } from 'react-hook-form';
import { Col, Grid, Row } from 'react-native-easy-grid';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import * as DocumentPicker from 'expo-document-picker';
import { LinearGradient } from 'expo-linear-gradient';
import { useHistory } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';

import HeaderTokenTwoOption from '@components/Headers/HeaderTokenTwoOption';
import styles from './style';
import JInput from '@components/common/JInput';
import ModalAlert from '@components/Modals/ModalAlert';
import ModalBack from '@components/Modals/ModalBack';
import { INPUT_BG, LINE_COLOR, TEXT_COLOR_GREEN } from '@assets/style/styleDefault';
import JButton from '@components/common/JButton';
import { JText as Text } from '@components/common/JText';

const TokenDetailDocument = ({ t }) => {
  const history = useHistory();
  const [isModal, setIsModal] = useState(false);

  const [isModalSave, setIsModalSave] = useState(false);
  const [isModalBack, setIsModalBack] = useState(false);
  const [file, setFile] = useState('');

  const schema = Yup.object().shape({
    emailName: Yup.string().required(t('errorMessages.TXT_REQUIRED')),
    subject: Yup.string().required(t('errorMessages.TXT_REQUIRED')),
    sourceAddress: Yup.string().email(t('errorMessages.TXT_EMAIL_REQUIRED')).required(t('errorMessages.TXT_REQUIRED')),
    bccAddress: Yup.string().email(t('errorMessages.TXT_EMAIL_REQUIRED')),
    thisArticleNote: Yup.string().required(t('errorMessages.TXT_REQUIRED')),
    mailBody: Yup.string().required(t('errorMessages.TXT_REQUIRED')),
  });

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isDirty, isValid },
  } = useForm({
    defaultValues: {
      emailName: '',
      subject: '',
      sourceAddress: '',
      bccAddress: '',
      thisArticleNote: '',
      mailBody: '',
    },
    resolver: yupResolver(schema),
    mode: 'onChange',
  });

  const openModal = () => {
    setIsModalSave(!isModalSave);
  };

  const onSubmit = (data) => console.log(data);

  const openModalBack = () => {
    if (isDirty || isValid) {
      setIsModalBack(!isModalBack);
    } else {
      history.push('/file-manager/other-notifications');
    }
  };

  const handleClick = () => {
    history.push('/file-manager/other-notifications/mail-notifications/test');
  };

  const otherModal = () => {
    setIsModalBack(false);
    setIsModal(true);
  };

  const saveAsDraft = () => {
    handleSubmit(onSubmit);
    reset();
    openModal();
  };

  const pickimages = async () => {
    let result = await DocumentPicker.getDocumentAsync({
      type: '*/*',
    });
    if (!result.cancelled) {
      setFile(result);
    }
  };

  return (
    <View style={styles.header}>
      <View style={[styles.positionSticky]}>
        <HeaderTokenTwoOption
          isDirty={isDirty}
          linkBtnBack="iconX.svg"
          actionBtnBack={openModalBack}
          textBtnBack={t('commonText.cancelButton')}
          linkIcon="mail.svg"
          textHeader={t('pages_FileManager_MailNotifications.textHeader')}
          widthIconTitle={36}
          heightIconTitle={36}
          scope1={
            <LinearGradient colors={['#32A5F7', '#2D81F3']} style={{ borderRadius: 5, width: 170, marginRight: 15 }}>
              <JButton
                disabled={!isDirty || !isValid}
                text={t('pages_FileManager_MailNotifications.buttonTestSMS')}
                width={170}
                textColor="white"
                onPressAction={handleClick}
              />
            </LinearGradient>
          }
          scope2={
            <LinearGradient colors={['#54DBB2', '#04C48B']} style={{ borderRadius: 5, width: 170 }}>
              <JButton
                text={t('commonText.buttonSave')}
                disabled={!isDirty}
                width={170}
                textColor="white"
                hasIcon
                linkIcon="iconDownload.svg"
                linkIconDisabled="iconDownloadGrey.svg"
                widthIcon={18}
                heightIcon={18}
                onPressAction={saveAsDraft}
              />
            </LinearGradient>
          }
        />
      </View>
      <ScrollView showsVerticalScrollIndicator={false}>
        <View style={[styles.borderForm]}>
          <Grid>
            <Row size={1} style={styles.borderBottomWhite}>
              <Col size={3} style={[styles.flexDirection, styles.titleInput]}>
                <Text style={styles.whiteColor}>{t('pages_FileManager_MailNotifications.emailName')} </Text>
                <Text style={styles.redColor}>✴︎</Text>
              </Col>
              <Col size={9}>
                <View>
                  <JInput
                    placeholder={t('pages_FileManager_MailNotifications.emailNamePlaceholder')}
                    prefix="mailInput.svg"
                    widthPrefix={22}
                    heightPrefix={22}
                    subfix="iconEdit.svg"
                    widthSubfix={18}
                    heightSubfix={18}
                    control={control}
                    name="emailName"
                    borderError={errors.emailName ? '#FF0000' : '#757575'}
                  />
                </View>
              </Col>
            </Row>
            <Row size={1} style={styles.borderBottomWhite}>
              <Col size={3} style={[styles.flexDirection, styles.titleInput]}>
                <Text style={styles.whiteColor}>{t('pages_FileManager_MailNotifications.subject')}</Text>
                <Text style={styles.redColor}>✴︎</Text>
              </Col>
              <Col size={9}>
                <View>
                  <JInput
                    placeholder={t('pages_FileManager_MailNotifications.subject')}
                    subfix="iconEdit.svg"
                    widthSubfix={18}
                    heightSubfix={18}
                    control={control}
                    name="subject"
                    paddingLeft={14}
                    borderError={errors.subject ? '#FF0000' : '#757575'}
                  />
                </View>
              </Col>
            </Row>
            <Row size={1} style={styles.borderBottomWhite}>
              <Col size={3} style={[styles.flexDirection, styles.titleInput]}>
                <Text style={styles.whiteColor}>{t('pages_FileManager_MailNotifications.sourceAddress')} </Text>
                <Text style={styles.redColor}>✴︎</Text>
              </Col>
              <Col size={9}>
                <View>
                  <JInput
                    placeholder={t('pages_FileManager_MailNotifications.sourceAddressPlaceholder')}
                    subfix="iconEdit.svg"
                    widthSubfix={18}
                    heightSubfix={18}
                    control={control}
                    name="sourceAddress"
                    paddingLeft={14}
                    borderError={errors.sourceAddress ? '#FF0000' : '#757575'}
                  />
                </View>
              </Col>
            </Row>
            <Row size={1} style={styles.borderBottomWhite}>
              <Col size={3} style={[styles.flexDirection, styles.titleInput]}>
                <Text style={styles.whiteColor}>{t('pages_FileManager_MailNotifications.bccAddress')} </Text>
              </Col>
              <Col size={9}>
                <View>
                  <JInput
                    placeholder={t('pages_FileManager_MailNotifications.bccAddressPlaceholder')}
                    subfix="iconEdit.svg"
                    widthSubfix={18}
                    heightSubfix={18}
                    control={control}
                    name="bccAddress"
                    paddingLeft={14}
                    borderError={errors.bccAddress ? '#FF0000' : '#757575'}
                  />
                </View>
              </Col>
            </Row>
            <Row size={1} style={styles.borderBottomWhite}>
              <Col size={3} style={[styles.flexDirection, styles.titleInput]}>
                <Text style={styles.whiteColor}>添付ファイル </Text>
              </Col>
              <Col size={9}>
                <View style={{ borderRadius: 4, flexDirection: 'row', alignItems: 'center' }}>
                  <JButton
                    text={file ? file.name : t('pages_FileManager_MailNotifications.pickImages')}
                    btnColor={INPUT_BG}
                    textColor={TEXT_COLOR_GREEN}
                    flexStart
                    justifyContent="space-between"
                    onPressAction={() => pickimages()}
                    borderButton="#757575"
                    iconSubfix="iconEdit.svg"
                    heightSubfix={18}
                    widthSubfix={18}
                  />
                </View>
              </Col>
            </Row>
            <Row size={8} style={styles.margin12}>
              <Col size={3} style={[styles.flexDirection, styles.titleInput]}>
                <Text style={styles.whiteColor}>{t('pages_FileManager_MailNotifications.mailBody')}</Text>
                <Text style={styles.redColor}>✴︎</Text>
              </Col>
              <Col size={9}>
                <View style={[styles.borderFormTextArea]}>
                  <View style={styles.inputArea}>
                    <JInput
                      placeholder={t('pages_FileManager_MailNotifications.mailBodyPlaceholder')}
                      subfix="iconEdit.svg"
                      widthSubfix={18}
                      heightSubfix={18}
                      control={control}
                      name="mailBody"
                      multiline={true}
                      heightMulti={340}
                      marginBottomErr={12}
                      border={`0px solid ${LINE_COLOR}`}
                    />
                  </View>
                  <View style={styles.inputTextArea}>
                    <JInput
                      placeholder={`${t('pages_FileManager_MailNotifications.thisArticleNotePlaceholder')}`}
                      subfix="iconEdit.svg"
                      widthSubfix={18}
                      heightSubfix={18}
                      control={control}
                      name="thisArticleNote"
                      multiline={true}
                      heightMulti={140}
                      marginBottomErr={12}
                      border={`1px solid ${LINE_COLOR}`}
                    />
                  </View>
                </View>
              </Col>
            </Row>
          </Grid>
        </View>
      </ScrollView>
      <ModalAlert
        isModalVisible={isModalSave}
        setModalVisible={setIsModalSave}
        modalText={t('pages_FileManager_MailNotifications.modalAlertText1')}
        iconWidth={16}
        iconHeight={12.5}
        icon="successGreen.svg"
        linkPage="/file-manager/other-notifications"
      />
      <ModalAlert
        isModalVisible={isModal}
        setModalVisible={setIsModal}
        modalText={t('pages_FileManager_MailNotifications.modalAlertText2')}
        iconWidth={16}
        iconHeight={12.5}
        icon="successGreen.svg"
        linkPage="tokens"
      />
      <ModalBack isModal={isModalBack} setIsModal={setIsModalBack} otherModal={otherModal} />
    </View>
  );
};
export default withNamespaces()(TokenDetailDocument);
